export default class InOrderIterator {
  constructor({ count, selectedIndex }) {
    this.count = count;
    this.selectedIndex = selectedIndex;
  }

  getNextIndex = () => {
    if (this.selectedIndex + 1 === this.count) {
      return 0;
    }

    return this.selectedIndex + 1;
  };

  getPreviousIndex = () => {
    if (this.selectedIndex === 0) {
      return this.count - 1;
    }

    return this.selectedIndex - 1;
  };
}
